import React, { FC, memo } from 'react';
import { media } from '@minecraft.themes';
import styled from 'styled-components';
import { useTranslation } from '@blocs.i18n';
import FormikInput from '@minecraft.formik-input';
import { FilterData } from '../../../shared/types';
import { FieldGroup, Delimiter, Label } from '../../../shared/styles';

const StyledFormikInput = styled(FormikInput)`
  ${media.md`
    max-width: 5rem;
  `}
`;

type Props = {
  rangeName: FilterData['name'];
  minName: FilterData['name'];
  maxName: FilterData['name'];
  label: FilterData['label'];
};

const VehicleYearRange: FC<Props> = ({ rangeName, minName, maxName, label }) => {
  const { t } = useTranslation();
  return (
    <>
      <Label>{label}</Label>
      <FieldGroup>
        <StyledFormikInput name={`${rangeName}.${minName}`} type="number" size="small" />
        <Delimiter>{t('common:filter.to')}</Delimiter>
        <StyledFormikInput name={`${rangeName}.${maxName}`} type="number" size="small" />
      </FieldGroup>
    </>
  );
};

export default memo(VehicleYearRange);
